var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.footer] = true, _obj[_vm.$style.footerFullWidth] = _vm.settings.isContentNoMaxWidth, _obj )},[_c('div',{class:_vm.$style.inner})])}
var staticRenderFns = []

export { render, staticRenderFns }